import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Grid
} from "@material-ui/core";
import api from "../../services/api";
import { toast } from "react-toastify";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const PublicForm = () => {
  const { slug } = useParams();
  const query = useQuery();
  const ticketId = query.get("ticketId");
  
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  
  // Mantiene los valores ingresados por el usuario
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const { data } = await api.get(`/public/forms/${slug}`);
        // data.fields puede ser un string JSON o array dependiendo del backend
        const fields = typeof data.fields === "string" ? JSON.parse(data.fields) : data.fields;
        setForm({ ...data, fields });
      } catch (err) {
        toast.error("Formulario no encontrado o no disponible.");
      }
      setLoading(false);
    };
    fetchForm();
  }, [slug]);

  const handleChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!ticketId) {
      toast.error("Enlace inválido. Falta ticketId.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post(`/public/forms/${slug}/submit`, {
        ticketId,
        data: formData
      });
      setSuccess(true);
    } catch (err) {
      toast.error(err?.response?.data?.error || "Ocurrió un error al enviar");
    }
    setSubmitting(false);
  };

  if (loading) {
    return (
      <Container maxWidth="sm" style={{ marginTop: "50px", textAlign: "center" }}>
        <CircularProgress />
      </Container>
    );
  }

  if (!form) {
    return (
      <Container maxWidth="sm" style={{ marginTop: "50px", textAlign: "center" }}>
        <Typography variant="h5">Formulario no encontrado</Typography>
      </Container>
    );
  }

  if (success) {
    return (
      <Container maxWidth="sm" style={{ marginTop: "50px" }}>
        <Paper elevation={3} style={{ padding: "30px", textAlign: "center" }}>
          <Typography variant="h5" color="primary" gutterBottom>
            ¡Gracias!
          </Typography>
          <Typography variant="body1">
            Tus datos han sido recibidos. Por favor, regresa a WhatsApp para continuar.
          </Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" style={{ marginTop: "50px", marginBottom: "50px" }}>
      <Paper elevation={3} style={{ padding: "30px" }}>
        <Typography variant="h5" gutterBottom align="center">
          {form.name}
        </Typography>
        {form.description && (
          <Typography variant="body1" color="textSecondary" paragraph align="center">
            {form.description}
          </Typography>
        )}

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {form.fields && form.fields.map((field, idx) => (
              <Grid item xs={12} key={idx}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label={field.label}
                  type={field.type === "textarea" ? "text" : field.type}
                  multiline={field.type === "textarea"}
                  rows={field.type === "textarea" ? 4 : 1}
                  required={field.required}
                  value={formData[field.name] || ""}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                />
              </Grid>
            ))}
            <Grid item xs={12} style={{ marginTop: "10px" }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                disabled={submitting}
              >
                {submitting ? <CircularProgress size={24} /> : "Enviar y Continuar"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

export default PublicForm;
